// extracted by mini-css-extract-plugin
export default {"headerContainer":"_606cf902","large":"_ce8c6b67","larger":"_c4c31395","titleWrapper":"_6ec57649","title":"_102fe5a","subtitle":"_1b3d489e","viewMore":"_e0ead4e2"};